<template>
  <div id="app" class="section">
    <div class="columns">
      <div class="column is-one-fifth">
      
      </div>
      <div class="column is-three-fifths">
        <comment-list v-bind:comments=comments></comment-list>
        <add-comment v-on:newComment="refreshList"></add-comment>
      </div>
      <div class="column is-one-fifth">
      
      </div>
    </div>
    </div>
</template>

<script>
// import HelloWorld from "./components/HelloWorld.vue";
import CommentList from "./components/CommentList.vue";
import AddComment from "./components/AddComment.vue";
import 'buefy/dist/buefy.css'
import axios from 'axios'

export default {
  name: "app",
  components: {
    CommentList,
    AddComment
  },
  data: function(){
    return {
      placeholder: '',
      comments: '',
      requestUrl: '/getcomments?url=' + decodeURIComponent(this.$route.params.url)
    }
  },
  methods:{

    refreshList: function(){
      axios //https://medium.com/js-dojo/how-to-deal-with-cors-error-on-vue-cli-3-d78c024ce8d3
        .get(this.requestUrl)   //TODO: url currently hardcoded
        .then(response => {
            this.comments = response
        })
        // .catch(error => {
        //     console.log(error)
        // });
    }
  },
  mounted () {
    axios //https://medium.com/js-dojo/how-to-deal-with-cors-error-on-vue-cli-3-d78c024ce8d3
        // .get('/getcomments?url=https://www.google.com/')   //TODO: url currently hardcoded
        .get(this.requestUrl)   //TODO: url currently hardcoded
        .then(response => {
            this.comments = response
        })
        // .catch(error => {
        //     console.log(error)
        // });
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding-top: 60px;
  background-color: #31ABBD;
  width: 100%;
  height: 100%;
}
</style>

